exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".dashboard .title-specifics{font-size:26px}.dashboard .graph-section{margin-top:10px;padding-top:10px;border-top:1px solid #f2efe8}.dashboard .no-results{height:250px;line-height:250px;text-align:center;color:gray}.dashboard .form-control{display:initial;width:auto;vertical-align:text-bottom}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/main/webapp/app/dashboard/dashboard.scss
// module id = 878
// module chunks = 0